import { render, staticRenderFns } from "./PlayerAvatar.vue?vue&type=template&id=70a22908"
import script from "./PlayerAvatar.vue?vue&type=script&lang=js"
export * from "./PlayerAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports